module.exports = __webpack_public_path__ + "static/media/UniviaPro-Light.4b807cb8.otf";